//import "jquery";
var $ = require('jquery');
require("jquery-mousewheel")($);
require('malihu-custom-scrollbar-plugin')($);

function dcScrollbar() {

  return {
    restrict: "EA",
    scope: {},
    //templateUrl : "modules/common/directives/portlet/portlet.tpl.html",
    link: function (scope, elem, attrs) {
      $(elem).mCustomScrollbar({
        theme: 'minimal-dark'
      });
    }
  };

}

export default angular.module("dc-ui.dcScrollbar",[])
  .directive("dcScrollbar",dcScrollbar)
  .name;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-scrollbar/dc-scrollbar.js